export default "__VITE_ASSET__D4UeLbsm__"